var map = {
	"./arrow.png": 68254,
	"./banner1.png": 61456,
	"./banner10.png": 69637,
	"./banner11.png": 22879,
	"./banner12.png": 94993,
	"./banner13.png": 73860,
	"./banner14.png": 14215,
	"./banner15.png": 52818,
	"./banner16.png": 83076,
	"./banner17.jpg": 58985,
	"./banner18.png": 86604,
	"./banner18_2.png": 46966,
	"./banner2.png": 33315,
	"./banner3.png": 45106,
	"./banner4.png": 76842,
	"./banner5.png": 65776,
	"./banner6.png": 69027,
	"./banner7.png": 49780,
	"./banner8.png": 82304,
	"./banner9.png": 47116,
	"./blog/blog1.png": 81385,
	"./blog/blog2.png": 6174,
	"./blog/blog3.png": 52983,
	"./blog/blog4.png": 4802,
	"./blog/blog5.png": 348,
	"./blog/blog6.png": 56334,
	"./blog/blog7.png": 460,
	"./blog/blog8.png": 40246,
	"./blog/token2049/1.png": 49611,
	"./blog/token2049/2.png": 25127,
	"./blog/token2049/3.png": 95040,
	"./blog/token2049/4.png": 75352,
	"./blog_page2_bg.png": 18018,
	"./blog_page_bg1.png": 47569,
	"./blog_page_bg2.png": 59814,
	"./blog_page_bg3.png": 75263,
	"./country.png": 18320,
	"./gameFi_page3_bg.png": 28853,
	"./gameFi_page5_icon1.png": 54585,
	"./gameFi_page5_icon2.png": 41884,
	"./homebg.png": 77719,
	"./homebg1.png": 52668,
	"./icon1.png": 14947,
	"./icon2.png": 96269,
	"./icon3.png": 5094,
	"./icon4.png": 56600,
	"./inter_download.png": 88910,
	"./inter_page3_bg.png": 70473,
	"./inter_page8_bg.png": 63930,
	"./inter_page8_img.png": 76728,
	"./invest1.png": 19410,
	"./invest10.png": 88920,
	"./invest11.png": 15771,
	"./invest12.png": 59483,
	"./invest13.png": 17100,
	"./invest14.png": 25411,
	"./invest15.png": 67047,
	"./invest16.png": 8252,
	"./invest17.png": 43428,
	"./invest2.png": 39522,
	"./invest3.png": 2807,
	"./invest4.png": 53564,
	"./invest5.png": 68661,
	"./invest6.png": 84320,
	"./invest7.png": 56264,
	"./invest8.png": 23252,
	"./invest9.png": 19394,
	"./investors.png": 79673,
	"./investors_bg.png": 95222,
	"./logo.png": 92079,
	"./nft_page_bg1.png": 6896,
	"./nft_page_bg2.png": 94422,
	"./nft_page_img1.png": 86174,
	"./nft_page_img2.png": 40470,
	"./nft_page_img3.png": 40944,
	"./on_sale.png": 8048,
	"./page10_bg.png": 90247,
	"./page10_img1.png": 98188,
	"./page10_img2.png": 43989,
	"./page10_img3.png": 45866,
	"./page11_icon1.png": 36236,
	"./page11_icon2.png": 85911,
	"./page11_icon3.png": 39386,
	"./page11_icon4.png": 49174,
	"./page11_icon5.png": 17035,
	"./page12_img1.png": 48797,
	"./page12_img1bg.png": 12143,
	"./page12_img2.png": 77282,
	"./page13_bg1.png": 90148,
	"./page13_bg2.png": 27420,
	"./page14_img1.png": 94537,
	"./page14_img2.png": 61198,
	"./page15_bg.png": 97135,
	"./page15_icon.png": 89410,
	"./page17_10m.png": 91019,
	"./page17_2m.png": 67680,
	"./page17_bg.png": 40529,
	"./page17_bg1.png": 60425,
	"./page17_bg2.png": 31442,
	"./page17_team_img1.png": 51919,
	"./page17_team_img10.jpg": 97232,
	"./page17_team_img10.png": 78860,
	"./page17_team_img10_1.png": 37162,
	"./page17_team_img2.png": 16419,
	"./page17_team_img3.png": 53474,
	"./page17_team_img4.png": 37665,
	"./page17_team_img5.png": 3314,
	"./page17_team_img6.png": 59417,
	"./page17_team_img7.png": 64890,
	"./page17_team_img8.png": 79137,
	"./page17_team_img9.png": 70822,
	"./page18_lanch_cont15img1.png": 72979,
	"./page18_lanch_cont15img10.jpg": 43991,
	"./page18_lanch_cont15img11.jpg": 36394,
	"./page18_lanch_cont15img12.jpg": 24787,
	"./page18_lanch_cont15img13.png": 41977,
	"./page18_lanch_cont15img14.png": 11200,
	"./page18_lanch_cont15img15.png": 47870,
	"./page18_lanch_cont15img16.png": 79496,
	"./page18_lanch_cont15img17.png": 17062,
	"./page18_lanch_cont15img18.png": 79837,
	"./page18_lanch_cont15img19.png": 86476,
	"./page18_lanch_cont15img2.png": 86405,
	"./page18_lanch_cont15img20.png": 1973,
	"./page18_lanch_cont15img21.jpg": 16976,
	"./page18_lanch_cont15img22.jpg": 82876,
	"./page18_lanch_cont15img23.jpg": 62378,
	"./page18_lanch_cont15img24.jpg": 84935,
	"./page18_lanch_cont15img25.jpg": 59585,
	"./page18_lanch_cont15img26.jpg": 22183,
	"./page18_lanch_cont15img27.jpg": 6872,
	"./page18_lanch_cont15img28.jpg": 67396,
	"./page18_lanch_cont15img29.jpg": 90578,
	"./page18_lanch_cont15img3.png": 95648,
	"./page18_lanch_cont15img30.jpg": 38441,
	"./page18_lanch_cont15img31.jpg": 14860,
	"./page18_lanch_cont15img32.jpg": 41576,
	"./page18_lanch_cont15img4.png": 51634,
	"./page18_lanch_cont15img5.png": 74694,
	"./page18_lanch_cont15img6.png": 58762,
	"./page18_lanch_cont15img7.png": 65861,
	"./page18_lanch_cont15img8.png": 4638,
	"./page18_lanch_cont15img9.png": 42178,
	"./page3_bg1.png": 84127,
	"./page3_bg2.png": 3083,
	"./page5_arrow.png": 26301,
	"./page5_bg.png": 13871,
	"./page5_img.png": 22069,
	"./page6_bg.png": 67615,
	"./page6_img1.png": 52196,
	"./page6_img2.png": 57578,
	"./page6_img3.png": 81874,
	"./page6_link.png": 63109,
	"./page7_img1.png": 2659,
	"./page8_icon.png": 11416,
	"./partner/partners1.png": 91127,
	"./partner/partners10.png": 27643,
	"./partner/partners11.png": 41767,
	"./partner/partners12.png": 29638,
	"./partner/partners13.png": 47700,
	"./partner/partners14.png": 72753,
	"./partner/partners15.png": 83833,
	"./partner/partners16.png": 18255,
	"./partner/partners17.png": 66893,
	"./partner/partners18.png": 33438,
	"./partner/partners19.png": 10460,
	"./partner/partners2.png": 32221,
	"./partner/partners20.png": 32948,
	"./partner/partners21.png": 59545,
	"./partner/partners22.png": 78454,
	"./partner/partners23.png": 56430,
	"./partner/partners24.png": 82684,
	"./partner/partners25.png": 45363,
	"./partner/partners26.png": 484,
	"./partner/partners27.png": 72705,
	"./partner/partners28.png": 56842,
	"./partner/partners29.png": 89334,
	"./partner/partners3.png": 26043,
	"./partner/partners30.png": 19066,
	"./partner/partners31.png": 10185,
	"./partner/partners32.png": 45481,
	"./partner/partners33.png": 58086,
	"./partner/partners34.png": 18636,
	"./partner/partners35.png": 77698,
	"./partner/partners4.png": 21944,
	"./partner/partners5.png": 73658,
	"./partner/partners6.png": 93934,
	"./partner/partners7.png": 13404,
	"./partner/partners8.png": 20071,
	"./partner/partners9.png": 25169,
	"./partner/partners_bg.png": 3100,
	"./sold_out.png": 81555,
	"./verified_bg.png": 28763,
	"./verified_btn.png": 21870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23616;